KROWN.themeName = 'Kingdom';
KROWN.themeVersion = '6.2.0';

// Shopify events

const executeOnceOnDomContentLoaded = ()=>{

	// input helpers

	document.querySelectorAll('input').forEach(elm=>{
		elm.addEventListener('change',e=>{
			if ( e.target.value != '' ) {
				e.target.classList.add('filled');
			} else {
				e.target.classList.remove('filled');
			}
		})
	});
	document.querySelectorAll('input[type="search"]').forEach(elm=>{elm.value=''});

	// a11y tab helper 

	let activeElement = document.activeElement;
	document.addEventListener('keyup', e=>{
		if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
      	activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('regular-select-cover') ||
      	e.target.classList.contains('search-field') ||
      	e.target.classList.contains('product-item__link') ||
      	e.target.classList.contains('content-slider') || 
      	e.target.classList.contains('blog-item__header') ||
      	e.target.classList.contains('toggle__title') ||
      	e.target.tagName == 'INPUT'
      ) {
      	activeElement = e.target;
        e.target.classList.add('focus');
      } 
    }
	});

  // newsletter has jump

	if ( window.location.search == '?customer_posted=true' ) {
		setTimeout(()=>{
			window.scroll({
			  top: document.querySelector('form .alert').offsetTop - 250, 
			  behavior: 'smooth'
			});
		}, 300);
	} else if ( window.location.pathname.includes('/challenge') ) {
		setTimeout(()=>{
			window.scroll({
			  top: 0, 
			  behavior: 'auto'
			});
		}, 300);
	}

}

if ( document.readyState !== 'loading' ) {
	executeOnceOnDomContentLoaded();
} else {
	document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		
		return fetch('?section_id=cart-helper')
			.then(response => {
				if ( ! response.ok ) throw new Error('Cart refresh failed: ' + response.status);
				return response.text();
			})
			.then(text => {

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const nextCart = sectionInnerHTML.getElementById('AjaxCartForm');
				const nextSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');
				const nextCount = nextCart && nextCart.querySelector('[data-cart-count]');
				const nextTotal = nextCart && nextCart.querySelector('[data-cart-total]');
				if ( ! nextCart || ! nextSubtotal || ! nextCount ) {
					throw new Error('Cart refresh returned incomplete section markup.');
				}

				const cartItems = document.getElementById('AjaxCartForm');
				if ( cartItems ) {
					cartItems.innerHTML = nextCart.innerHTML;
					// Kingdom only loads the AJAX cart component for overlay and cart pages.
					if ( typeof cartItems.ajaxifyCartItems === 'function' ) cartItems.ajaxifyCartItems();
				}
				document.querySelectorAll('[data-header-cart-count]').forEach(elm => elm.textContent = nextCount.textContent);
				if ( nextTotal ) document.querySelectorAll('[data-header-cart-total]').forEach(elm => elm.innerHTML = nextTotal.innerHTML);

				const subtotal = document.getElementById('AjaxCartSubtotal');
				if ( subtotal ) subtotal.innerHTML = nextSubtotal.innerHTML;

				const drawer = document.querySelector('.sidebar__cart');
				if ( openDrawer && KROWN.settings.cart_action === 'overlay' && drawer && typeof drawer.show === 'function' ) drawer.show();
				return sectionInnerHTML;

			})
			.catch(error => {
				// A successful app cart mutation must not become an unhandled UI refresh error.
				console.warn('Kingdom cart refresh:', error);
				return null;
			});

	}

}
